import { createCustomEnum } from "../customEnum";

const CreditDebitByValueTypeCartTypes = createCustomEnum({
	DateOfOrder: {
		value: 0,
		name: "DateOfOrder",
		displayName: "Date of Order",
	},
	DateOfShipment: {
		value: 1,
		name: "DateOfShipment",
		displayName: "Date of Shipment",
	},
	Other: {
		value: 2,
		name: "Other",
		displayName: "Other",
	},
});

export default CreditDebitByValueTypeCartTypes;
